import { diagnosisBaseModel } from './crud';

export * from './types';

export const useDiagnosesById = diagnosisBaseModel.fetchById();
export const useDiagnosesByIds = diagnosisBaseModel.fetchByIds();
export const useDiagnosesMany = diagnosisBaseModel.fetchMany();
export const useDiagnosesCount = diagnosisBaseModel.count();
export const useDiagnosesManyInfiniteQuery =
  diagnosisBaseModel.fetchPaginated();
export const useDiagnosesUpdateOne = diagnosisBaseModel.edit();
export const useDiagnosesCreateOne = diagnosisBaseModel.create();
export const useDiagnosesRemoveOne = diagnosisBaseModel.delete();
export const useDiagnosesRemoveByIds = diagnosisBaseModel.deleteByIds();

export const useDiagnosesByIdV2 = diagnosisBaseModel.fetchByIdV2();
export const useDiagnosesByIdsV2 = diagnosisBaseModel.fetchByIdsV2();
export const useDiagnosesManyV2 = diagnosisBaseModel.fetchManyV2();
export const useDiagnosesCountV2 = diagnosisBaseModel.countV2();
export const useDiagnosesManyInfiniteQueryV2 =
  diagnosisBaseModel.fetchPaginatedV2();
export const useDiagnosesUpdateOneV2 = diagnosisBaseModel.editV2();
export const useDiagnosesCreateOneV2 = diagnosisBaseModel.createV2();
export const useDiagnosesRemoveOneV2 = diagnosisBaseModel.deleteV2();
export const useDiagnosesRemoveByIdsV2 = diagnosisBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useDiagnosisById = diagnosisBaseModel.fetchById();
export const useDiagnosisByIds = diagnosisBaseModel.fetchByIds();
export const useDiagnosisMany = diagnosisBaseModel.fetchMany();
export const useDiagnosisCount = diagnosisBaseModel.count();
export const useDiagnosisPagination = diagnosisBaseModel.fetchPaginated();
export const useDiagnosisUpdateOne = diagnosisBaseModel.edit();
export const useDiagnosisCreateOne = diagnosisBaseModel.create();
export const useDiagnosisRemoveOne = diagnosisBaseModel.delete();
export const useDiagnosisRemoveByIds = diagnosisBaseModel.deleteByIds();

export const useDiagnosisByIdV2 = diagnosisBaseModel.fetchByIdV2();
export const useDiagnosisByIdsV2 = diagnosisBaseModel.fetchByIdsV2();
export const useDiagnosisManyV2 = diagnosisBaseModel.fetchManyV2();
export const useDiagnosisCountV2 = diagnosisBaseModel.countV2();
export const useDiagnosisPaginationV2 = diagnosisBaseModel.fetchPaginatedV2();
export const useDiagnosisUpdateOneV2 = diagnosisBaseModel.editV2();
export const useDiagnosisCreateOneV2 = diagnosisBaseModel.createV2();
export const useDiagnosisRemoveOneV2 = diagnosisBaseModel.deleteV2();
export const useDiagnosisRemoveByIdsV2 = diagnosisBaseModel.deleteByIdsV2();
